<script lang="ts">
    import {modal} from 'general/store';
    import type {DyMainButtonType} from 'types/dy';
    import DyButton from '../dyButton/DyButton.svelte';

    import s from './style.module.css';

    export let type: 'submit' | 'button' | 'reset' = 'submit';

    export let onClick: () => void = () => {};
    export let disabled = false;
    export let children: any;
    export let template = 'circle';
    export let dyButtonData: DyMainButtonType = null;
    export let pointer = true;
</script>

{#if dyButtonData}
    <DyButton {disabled} {children} {type} {pointer} {onClick} {...dyButtonData} />
{:else}
    <button
        class="{s.button} {s[template] || ''} {s[$modal.state]}"
        {disabled}
        {type}
        on:click={onClick}
    >
        {children}
    </button>
{/if}
